var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"bounce","mode":"in-out"},on:{"before-enter":_vm.beforeEnter,"after-enter":_vm.afterEnter}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }